import React from 'react';
import { TransactionTable } from './TransactionTable';

export const TransactionList: React.FC = () => {
  return <TransactionTable />;
};
